import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { Link, withRouter } from 'react-router-dom';
import { Button } from 'reactstrap';

import { savePage, updatePage } from './actions';
import SelectField from '../../components/common/SelectField';
import Editor from '../../components/common/Editor';
import TextField from '../../components/common/TextField';
import { PAGE_FORM_NAME } from './constants';

const required = value => (value ? undefined : 'Povinný údaj');

class PageForm extends Component {
  onSubmit = formProps => {
    const { lang } = formProps;
    const { config } = this.props;

    const pageRequestData = {
      title: formProps.title,
      content: formProps.content,
      description: formProps.description,
      slug: formProps.slug
    };

    if (config && config.id) {
      // add new mutation for existing article
      this.props.updatePage(pageRequestData, config.id, lang, () => {
        this.props.history.push('/zakladni-stranky');
      });
    } else {
      // create brand new article
      this.props.savePage(pageRequestData, lang, () => {
        this.props.history.push('/zakladni-stranky');
      });
    }
  };

  render() {
    const { config, handleSubmit } = this.props;

    return (
      <div className="new-page">
        <form onSubmit={handleSubmit(this.onSubmit)}>
          <Field
            key="lang"
            component={SelectField}
            label="Jazyk"
            name="lang"
            disabled={config ? config.disableSelect : false}
            validate={required}
          >
            <option value="" key="empty">
              Vyberte jazyk
            </option>
            <option value="cs" key="cs">
              CZ
            </option>
            <option value="en" key="en">
              EN
            </option>
          </Field>
          <div className="editor">
            <Field
              name="content"
              component={Editor}
              label="Obsah"
              validate={required}
            />
          </div>
          <Field
            component={TextField}
            type="text"
            label="Title"
            name="title"
            validate={required}
          />
          <Field
            component={TextField}
            type="text"
            label="Url"
            name="slug"
            placeholder="nova-stranka"
            validate={required}
          />
          <Field
            component={TextField}
            type="textarea"
            label="Meta description"
            name="description"
            validate={required}
          />
          <div className="form-buttons">
            <Button color="primary">Uložit</Button>
            <Button tag={Link} to="/zakladni-stranky" color="danger">
              Zpět
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = {
  savePage,
  updatePage
};

export default compose(
  withRouter,
  connect(
    null,
    mapDispatchToProps
  ),
  reduxForm({ form: PAGE_FORM_NAME })
)(PageForm);



// WEBPACK FOOTER //
// ./src/modules/PageForm/index.js